import React, { useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom"; 
import DatePicker from "react-datepicker";
import { RiMapPin2Line, RiCalendarEventLine, RiSearch2Line, RiArrowLeftRightLine } from "react-icons/ri";
import styles from "./SearchBusPanel3.module.css";

const SearchBusPanel3 = ({ onSearch, mode, onNavigate, templateId }) => {
  const navigate = useNavigate();
  const [fromStation, setFromStation] = useState("HYDERABAD");
  const [toStation, setToStation] = useState("BANGALORE");
  const [travelDate, setTravelDate] = useState(new Date());

  const handleSearch = (e) => {
    e.preventDefault();
    const searchQuery = {
      fromStation, toStation,
      travelDate: moment(travelDate).format("YYYY-MM-DD"),
    };
    if (mode === "builder") onNavigate({ name: "bus-results", params: { searchQuery } });
    else onSearch(searchQuery);
  };

  return (
    <div className={styles.panelWrapper}>
      <div className={styles.inputBox}>
        <div className={styles.field}>
          <label>From</label>
          <div className={styles.inputWrap}>
            <RiMapPin2Line className={styles.icon} />
            <input value={fromStation} onChange={(e) => setFromStation(e.target.value)} />
          </div>
        </div>

        <button className={styles.swapBtn} onClick={() => {
            const temp = fromStation;
            setFromStation(toStation);
            setToStation(temp);
        }}>
          <RiArrowLeftRightLine />
        </button>

        <div className={styles.field}>
          <label>To</label>
          <div className={styles.inputWrap}>
            <RiMapPin2Line className={styles.icon} />
            <input value={toStation} onChange={(e) => setToStation(e.target.value)} />
          </div>
        </div>

        <div className={styles.field}>
          <label>Date</label>
          <div className={styles.inputWrap}>
            <RiCalendarEventLine className={styles.icon} />
            <DatePicker 
                selected={travelDate} 
                onChange={setTravelDate} 
                className={styles.dateInput}
            />
          </div>
        </div>

        <button className={styles.searchBtn} onClick={handleSearch}>
          <RiSearch2Line />
          <span>Search</span>
        </button>
      </div>
    </div>
  );
};

export default SearchBusPanel3;